
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

interface DashboardHeaderProps {
  onSidebarToggle: () => void;
}

const DashboardHeader = ({ onSidebarToggle }: DashboardHeaderProps) => {
  return (
    <header className="bg-white border-b border-gray-200 px-4 lg:px-8 py-4 flex justify-between items-center">
      {/* Mobile Menu Button */}
      <button
        onClick={onSidebarToggle}
        className="lg:hidden p-2 rounded-md hover:bg-gray-100"
      >
        <Menu className="w-6 h-6" />
      </button>
      
      <div className="flex-1 lg:flex-none"></div>
      <div className="flex items-center space-x-2 lg:space-x-4">
        <span className="text-xs lg:text-sm text-gray-600 hidden sm:block">Your free trial has ended</span>
        <Button className="bg-purple-600 hover:bg-purple-700 text-white px-3 lg:px-4 py-2 rounded-lg text-sm">
          Upgrade
        </Button>
        <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white font-medium">
          M
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
